import {minNumber} from "../../utils/util";

export let getPaginationNormalTpl = function (paginationObj) {
  let firstPageIndex = paginationObj.start || 1,
    lastPageIndex = paginationObj.end || 1,
    currentPageIndex = paginationObj.currentPage || 1,
    prevPageIndex = (firstPageIndex - 1 >= 1) ? firstPageIndex - 1 : 0,
    nextPageIndex = (lastPageIndex + 1 <= paginationObj.maxPageNo) ? lastPageIndex + 1 : 0;

  let tpl = '';
  if (prevPageIndex > 0) {
    tpl += `<li class="prev">
              <a href="?page=${prevPageIndex}" data-paging="${prevPageIndex}">
                <i class="fe-icon-paging-prev"></i>
              </a>
            </li>`;
  }

  for (let i = firstPageIndex, max = lastPageIndex; i <= max; i++) {
    if (i === currentPageIndex) {
      tpl += `<li class="current">${i}</li>`;

    } else {
      tpl += `<li><a href="?page=${i}" data-paging="${i}">${i}</a></li>`;
    }
  }

  if (nextPageIndex > 0) {
    tpl += `<li class="next">
              <a href="?page=${nextPageIndex}" data-paging="${nextPageIndex}">
                <i class="fe-icon-paging-next"></i>
              </a>
            </li>`;
  }

  return tpl;
};

export let getPaginationSearchTpl = function (paginationObj) {
  let firstPageIndex = paginationObj.start || 1,
      lastPageIndex = paginationObj.end || 1,
      currentPageIndex = paginationObj.currentPage || 1,
      prevPageIndex = (firstPageIndex - 1 >= 1) ? firstPageIndex - 1 : 0,
      nextPageIndex = (lastPageIndex + 1 <= paginationObj.maxPageNo) ? lastPageIndex + 1 : 0;

  console.log('# paginationObj : ', paginationObj, lastPageIndex, currentPageIndex, prevPageIndex, nextPageIndex);
  let tpl = '';
  if (prevPageIndex > 0) {
    tpl += `<li class="prev">
              <a href="?page=${prevPageIndex}" data-paging="${prevPageIndex}">
                <i class="fe-icon-paging-prev"></i>
              </a>
            </li>`;
  }

  for (let i = firstPageIndex, max = lastPageIndex; i <= max; i++) {
    if (i === currentPageIndex) {
      tpl += `<li class="current">${i}</li>`;

    } else {
      tpl += `<li><a href="?page=${i}" data-paging="${i}">${i}</a></li>`;
    }
  }

  if (nextPageIndex > 0) {
    tpl += `<li class="next">
              <a href="?page=${nextPageIndex}" data-paging="${nextPageIndex}">
                <i class="fe-icon-paging-next"></i>
              </a>
            </li>`;
  }

  return tpl;
};

export let getPaginationEventTpl = function (paginationObj) {
  let firstPageIndex = paginationObj.start || 1,
    lastPageIndex = paginationObj.end || 1,
    currentPageIndex = paginationObj.current || 1,
    prevPageIndex = (firstPageIndex - 1 >= 1) ? firstPageIndex - 1 : 0,
    nextPageIndex = (lastPageIndex + 1 <= paginationObj.last) ? lastPageIndex + 1 : 0;

  let tpl = '';
  if (prevPageIndex > 0) {
    tpl += `<li class="prev">
              <a href="?page=${prevPageIndex}" data-paging="${prevPageIndex}">
                <i class="fe-icon-paging-prev"></i>
              </a>
            </li>`;
  }

  for (let i = firstPageIndex, max = lastPageIndex; i <= max; i++) {
    if (i === currentPageIndex) {
      tpl += `<li class="current">${i}</li>`;

    } else {
      tpl += `<li><a href="?page=${i}" data-paging="${i}">${i}</a></li>`;
    }
  }

  if (nextPageIndex > 0) {
    tpl += `<li class="next">
              <a href="?page=${nextPageIndex}" data-paging="${nextPageIndex}">
                <i class="fe-icon-paging-next"></i>
              </a>
            </li>`;
  }

  return tpl;
};


// WEBPACK FOOTER //
// ./_src/js/model/tpl/paginationNormal.js